var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 763.34 495.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #e118ff;\n      }\n\n      .cls-4 {\n        fill: none;\n        stroke: #c515e0;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n\n      .cls-5 {\n        fill: #2300ff;\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 251.66,
    y1: 135.65,
    x2: 539.35,
    y2: 145.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#2300ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 304.74,
    y1: 182.63,
    x2: 527.26,
    y2: 186.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2300ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14008c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m11.22,338.9h11.95v84.22h46.64v10.22H11.22v-94.44Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "123.01 372.4 90.69 374.66 90.02 365.04 134.25 361.95 139.13 431.74 127.22 432.58 123.01 372.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m115.93,339.27c-.38-5.46,3.38-9.47,8.84-9.85,5.46-.38,9.74,3.07,10.12,8.53.39,5.6-3.38,9.47-8.83,9.85s-9.73-2.93-10.12-8.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m170.71,338.9h12.96l15.12,50.96c3.31,11.08,5.61,20.15,9.07,31.1h.58c3.45-10.94,5.9-20.01,9.07-31.1l15.12-50.96h12.38l-29.94,94.44h-14.11l-30.23-94.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m267.44,338.9h58.45v10.22h-46.36v29.51h39.16v10.22h-39.16v34.26h47.8v10.22h-59.89v-94.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m443.06,338.9h11.95v84.22h46.64v10.22h-58.59v-94.44Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "556.07 373.67 523.76 371.41 524.43 361.79 568.67 364.88 563.78 434.68 551.87 433.84 556.07 373.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m553.67,339.88c.38-5.46,4.66-8.91,10.12-8.53,5.46.38,9.22,4.4,8.83,9.85s-4.66,8.91-10.12,8.53c-5.46-.38-9.23-4.25-8.84-9.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m603.7,363.37h12.24l16.12,39.59c2.74,7.05,5.33,13.96,7.77,20.73h.58c2.45-6.77,4.75-13.68,7.63-20.73l16.13-39.59h11.52l-29.08,69.97h-13.39l-29.51-69.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m692.66,398.21c0-22.74,16.99-36.57,35.71-36.57,20.15,0,31.96,13.1,31.96,32.82,0,2.74-.29,5.33-.57,7.2h-59.17v-9.21h52.11l-3.02,3.31c0-16.55-8.21-24.76-21.02-24.76s-24.18,9.79-24.18,27.21,11.8,27.35,27.35,27.35c8.35,0,14.97-2.59,21.31-6.62l4.32,7.77c-6.91,4.61-15.83,8.35-27.06,8.35-21.02,0-37.72-13.53-37.72-36.85Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m0,495.52v-33.06h35.47v5.84H8.13v7.21h15.92v5.69h-15.92v8.13h27.76v6.18H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m60.05,495.52v-33.06h5.54l28.06,21.95v-21.95h7.29v33.06h-5.58l-27.99-22.3v22.3h-7.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m147.94,468.37v27.15h-8.06v-27.15h-15.96v-5.92h40.02v5.92h-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m186.87,495.52v-33.06h35.47v5.84h-27.34v7.21h15.92v5.69h-15.92v8.13h27.76v6.18h-35.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m246.92,495.52v-33.06h29.78c2.72,0,4.7.5,5.92,1.51,1.22,1.01,1.83,2.64,1.83,4.91v7.79c0,2.24-.61,3.86-1.83,4.85-1.22.99-3.2,1.49-5.92,1.49h-4.54l15.73,12.52h-11.57l-13.86-12.52h-7.6v12.52h-7.94Zm26.35-27.38h-18.4v9.17h18.4c1.4,0,2.36-.2,2.88-.61.52-.41.78-1.09.78-2.06v-3.82c0-.97-.26-1.65-.78-2.06-.52-.41-1.48-.61-2.88-.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m327.17,468.37v27.15h-8.06v-27.15h-15.96v-5.92h40.02v5.92h-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m355.38,495.52l19.63-33.06h7.75l19.93,33.06h-9.05l-4.16-7.25h-21.88l-4.16,7.25h-8.06Zm15.66-13.29h15.16l-7.71-13.78-7.45,13.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m423.45,495.52v-33.06h8.02v33.06h-8.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m458.72,495.52v-33.06h5.54l28.06,21.95v-21.95h7.29v33.06h-5.58l-27.99-22.3v22.3h-7.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m526.9,495.52v-33.06h6.45l16.19,19.63,16.11-19.63h6.49v33.06h-7.48v-22.76l-14.78,18.78h-1.57l-14.97-18.25v22.22h-6.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m599.4,495.52v-33.06h35.47v5.84h-27.34v7.21h15.92v5.69h-15.92v8.13h27.76v6.18h-35.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m659.45,495.52v-33.06h5.54l28.06,21.95v-21.95h7.29v33.06h-5.58l-27.99-22.3v22.3h-7.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m747.34,468.37v27.15h-8.06v-27.15h-15.96v-5.92h40.02v5.92h-16Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m535.91,128.39c5.1,2.55,5.1,9.82,0,12.37l-117.29,58.65-58.94,29.48-35.36,17.68-51,25.5c-4.12,2.06-9.1-.42-9.9-4.95-14.68-83.29-15.33-162.88-1.2-255.37,1.41-9.26,11.48-14.46,19.87-10.27l34.59,17.3c4.69,2.34,7.65,7.13,7.65,12.37v138.33c0,5.14,5.41,8.49,10.01,6.19l25.36-12.68,58.94-29.48,35.36-17.68,25.31-12.65c1.95-.97,4.24-.97,6.18,0l27.44,13.72,22.99,11.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m430.11,75.49c5.1,2.55,5.1,9.82,0,12.37l-11.49,5.74-48.93,24.47c-4.6,2.3-10.01-1.04-10.01-6.19v-60.42c0-5.14,5.41-8.48,10.01-6.19l48.93,24.46,11.49,5.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m527.08,134.2l-221.31,104.54,219.58-108.14c.99-.49,2.19-.08,2.68.91.49.99.08,2.19-.91,2.68,0,0-.02.01-.03.01Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 365.46,
    y1: 51.48,
    x2: 365.46,
    y2: 111.87
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset1);
export default __webpack_public_path__ + "static/media/Asset 1.4ad30ae22cfafb2b728ef670e171d1ff.svg";
export { ForwardRef as ReactComponent };